import React, { Component } from 'react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts'

export default class Graph extends Component {
  render() {
    return (
        <div className="row ">
        <div className="col-md-12">
            <div className="col-md-6 col-sm-12 content-center" >
                <BarChart width={600} height={400} data={this.props.graph_data}
                    margin={{top: 5, right: 20, left: 20, bottom: 5}}>
                    <XAxis dataKey="name"/>
                    <YAxis/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Tooltip/>
                    <Legend />
                    <Bar dataKey="pv" fill="#8884d8" />
                    <Bar dataKey="uv" fill="#82ca9d" />
                </BarChart>
           </div>
         <div className="col-md-6 col-sm-12" ></div>
      </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/Dashboard/dashboard_graph.js